//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
import { getBeneficiaryDetails } from 'state/reducers/beneficiary.reducers';
//theme
import { HeaderPage1 } from 'theme/elements/Headers';

export default function CreateHeader(props: { isEdit?: boolean }) {
	const t = useAppSelector(selectTranslations);
	return (
		<HeaderPage1
			title={props.isEdit ? t('page.beneficiary.edit.header.title') : t('page.beneficiary.create.header.title')}
			text={t('page.beneficiary.create.header.text')}
		/>
	);
}
